import _u from '../shared/utils';
import {globalActions} from "../store/global-actions";

const Dropdown = {
    props: {
        withOverlay: {},
        event: {},
    },
    emits: ['open', 'close'],
    data() {
        return {
            isOpen: false,
            uniqueId: _u.genUid(),
        };
    },
    methods: {
        open() {
            this.isOpen = true;
            this.$emit('open');
            globalActions.openDropdown(this.uniqueId);
        },

        close() {
            this.isOpen = false;
            this.$emit('close');
            globalActions.closeDropdown(this.uniqueId);
        },
        toggle() {
            this.isOpen ? this.close() : this.open();
        },
    },
};

export default Dropdown;
